"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var MobileCompareVersionsComponent = /** @class */ (function () {
    function MobileCompareVersionsComponent(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
        this._isPopup = false;
    }
    Object.defineProperty(MobileCompareVersionsComponent.prototype, "isPopup", {
        get: function () {
            return this._isPopup;
        },
        set: function (value) {
            this._isPopup = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MobileCompareVersionsComponent.prototype, "title", {
        get: function () {
            if (this.data.title != null) {
                return this.data.title;
            }
            return "";
        },
        enumerable: true,
        configurable: true
    });
    MobileCompareVersionsComponent.prototype.ngOnInit = function () {
    };
    MobileCompareVersionsComponent.prototype.closeAction = function () {
        if (this.isPopup)
            this.dialogRef.closeAll();
    };
    return MobileCompareVersionsComponent;
}());
exports.MobileCompareVersionsComponent = MobileCompareVersionsComponent;
var MobileCompareVersionsPageComponent = /** @class */ (function () {
    function MobileCompareVersionsPageComponent(dialogRef) {
        this.dialogRef = dialogRef;
        this._isPopup = false;
    }
    Object.defineProperty(MobileCompareVersionsPageComponent.prototype, "isPopup", {
        get: function () {
            return this._isPopup;
        },
        set: function (value) {
            this._isPopup = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MobileCompareVersionsPageComponent.prototype, "title", {
        get: function () {
            return "";
        },
        enumerable: true,
        configurable: true
    });
    MobileCompareVersionsPageComponent.prototype.closeAction = function () { };
    MobileCompareVersionsPageComponent.prototype.ngOnInit = function () {
    };
    return MobileCompareVersionsPageComponent;
}());
exports.MobileCompareVersionsPageComponent = MobileCompareVersionsPageComponent;
